import { ChevronDown, ChevronRight, Download } from 'react-feather';
import { formatPhoneNumber } from '../../hooks/phoneFormat';
import { normalizeClientAddress } from '../../utils/addressUtils';

export default function OrderClientInfo({ 
    client, 
    sections, 
    toggleSection, 
    handdelDifferentClient, 
    getUserName 
}) {
    if (!client?.id) return null;
    const clientAddress = normalizeClientAddress(client);

    return (

        <div className="order-client-info-wrapper margin-top"> 
            {/* Added wrapper div to hold both blocks if needed, or Fragment logic */}
            
            {/* Block 1: Client Information */}
            <div className="tab-information">
                <div className="tab-information-block">
                    <div className="user-information">
                        <div
                            className="title-block relative pr-12"
                            onClick={(e) => toggleSection('client', e)}
                        >
                            <h2 className="title-h2">Client Information</h2>
                            
                            <div className="absolute right-12 top-1/2 -translate-y-1/2" onClick={(e) => e.stopPropagation()}>
                                <button
                                    className="flex items-center text-xs font-semibold text-blue-600 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-md transition-colors border border-blue-200"
                                    onClick={() => handdelDifferentClient()}
                                >
                                    Different Client <List size={14} className="ml-2" />
                                </button>
                            </div>

                            <button>
                                {sections.client ? (
                                    <ChevronDown size={24} />
                                ) : (
                                    <ChevronRight size={24} />
                                )}
                            </button>
                        </div>
                        
                        {sections.client && (
                            <div className="grid grid-flow-row-dense grid-cols-2 grid-rows-2 content-block mt-4">
                                <div className="data-content">
                                    <p><strong>First Name</strong> {client?.firstName}</p>
                                </div>
                                <div className="data-content">
                                    <p><strong>Last Name</strong> {client?.lastName}</p>
                                </div>
                                <div className="data-content">
                                    <p><strong>Email</strong> {client?.email}</p>
                                </div>
                                <div className="data-content">
                                    <p>
                                        <strong>Phone</strong>{' '}
                                        {client?.phoneNumber
                                            ? formatPhoneNumber(client?.phoneNumber)
                                            : 'N/A'}
                                    </p>
                                </div>
                                <div className="data-content">
                                    <p><strong>Street</strong> {clientAddress.address}</p>
                                </div>
                                <div className="data-content">
                                    <p><strong>City</strong> {clientAddress.city}</p>
                                </div>
                                <div className="data-content">
                                    <p><strong>State</strong> {clientAddress.state}</p>
                                </div>
                                <div className="data-content">
                                    <p><strong>Zipcode</strong> {clientAddress.postalCode}</p>
                                </div>
                                <div className="data-content">
                                    <p>
                                        <strong>User Created </strong>{' '}
                                        {new Date(client.createdAt).toLocaleString(
                                            'en-US',
                                            {
                                                month: '2-digit',
                                                day: '2-digit',
                                                year: '2-digit',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                            }
                                        )}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Block 2: Client Notes - Separate Card */}
            <div className="tab-information margin-top-20"> 
               {/* Added margin-top-20 or equivalent class if exists, or style */}
                <div className="tab-information-block">
                    <div
                        className="title-block"
                        onClick={(e) => toggleSection('notesTab', e)}
                    >
                        <h2 className="title-h2">Client Notes</h2>
                        <button>
                            {sections.notesTab ? (
                                <ChevronDown size={24} />
                            ) : (
                                <ChevronRight size={24} />
                            )}
                        </button>
                    </div>
                    {sections.notesTab && (
                        <div className="new-order-form">
                            <div className="field-section-full">
                                {client?.notes &&
                                    client?.notes.map((note, index) => (
                                        <div key={index} className="notesList">
                                            <span className="notes-item-title">
                                                <strong>Date:</strong>{' '}
                                                {new Date(note?.createdAt).toLocaleString(
                                                    'en-US',
                                                    {
                                                        month: '2-digit',
                                                        day: '2-digit',
                                                        year: '2-digit',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                    }
                                                )}
                                            </span>
                                            <p className="notes-item-title">
                                                {note && note?.userId && (
                                                    <strong>Account manager:</strong>
                                                )}
                                                {note &&
                                                    note?.userId &&
                                                    getUserName(note?.userId)}
                                            </p>
                                            <span className="whitespace-normal"></span>
                                            <div className="notes-item-value">
                                                <strong>Comments:</strong>
                                                <br />
                                                {note?.text}
                                            </div>
                                            <div className="field-section-full download-array">
                                                {note?.attachments?.length > 0 && (
                                                    <strong className="w-full">
                                                        Download attachments
                                                    </strong>
                                                )}
                                                {note?.attachments &&
                                                    note.attachments.map((file, index) => (
                                                        <div
                                                            key={index}
                                                            className="notes-item-attachment"
                                                        >
                                                            <a
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    window.open(
                                                                        file.url,
                                                                        '_blank',
                                                                        'noopener,noreferrer'
                                                                    );
                                                                }}
                                                                className="btn-download-file"
                                                            >
                                                                <Download size={12} />
                                                            </a>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

// Internal Icons used in this component
function List({ size }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="8" y1="6" x2="21" y2="6"></line>
            <line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line>
            <line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line>
            <line x1="3" y1="18" x2="3.01" y2="18"></line>
        </svg>
    );
}
